import { render, staticRenderFns } from "./SelectServices.vue?vue&type=template&id=2e1b584c"
import script from "./SelectServices.vue?vue&type=script&lang=js"
export * from "./SelectServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports